import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { productGridCardStyles } from "@insite/content-library/Widgets/ProductList/ProductListProductGridCard";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

productGridCardStyles.wrapper = mergeToNew(productGridCardStyles.wrapper, {
    css: css`
        border: 1px solid ${getColor("common.border")};
        border-radius: 12px;
        height: 100%;
        display: flex;
        flex-direction: column;
        overflow: hidden;
    `,
});

productGridCardStyles.imageWrapper = mergeToNew(productGridCardStyles.imageWrapper, {
    css: css`
        margin: 10px 0;
        > div {
            align-items: center;
            > a {
                max-height: 229px;
                height: 229px;
                max-width: 229px;
                display: flex;
                justify-content: center;
                > img {
                    max-height: 100%;
                    width: auto;
                    max-width: 100%;
                }
            }
        }
    `,
});
